const restructureData = elements => {
  const newElements = elements.filter(element => Array.isArray(element))
  return newElements.length ? elements : [[...elements]]
}

export default restructureData
